/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://wr3ospikbd.execute-api.eu-west-1.amazonaws.com/openprod",
            "region": "eu-west-1"
        },
        {
            "name": "authUtils",
            "endpoint": "https://ms9ks6olg5.execute-api.eu-west-1.amazonaws.com/openprod",
            "region": "eu-west-1"
        },
        {
            "name": "utils",
            "endpoint": "https://fl81amsue9.execute-api.eu-west-1.amazonaws.com/openprod",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://5v4ss7o6xbaxfmaw4vcdibvihi.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-3lrnehaxhvcunaume2psnpctay",
    "aws_cognito_identity_pool_id": "eu-west-1:91958726-1fef-459f-b0c7-9b0281356e76",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_pLIza3yoN",
    "aws_user_pools_web_client_id": "nq3lid998sp9mt4m086vju1cv",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "senseus-contenta432b-openprod",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
